import { render } from "./CustomHeadToHeadResults.vue?vue&type=template&id=75760a0f&scoped=true"
import script from "./CustomHeadToHeadResults.vue?vue&type=script&lang=js"
export * from "./CustomHeadToHeadResults.vue?vue&type=script&lang=js"

import "./CustomHeadToHeadResults.vue?vue&type=style&index=0&id=75760a0f&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75760a0f"]])

export default __exports__